import type { ParticipantType } from '@/api/chat/types';
import { PagePaths } from '@/routes/page-paths';

import { SHELL_PARAM } from '../hooks/use-shell-url-state';

interface GetCommunicationContactPath {
  recipientType: ParticipantType;
  recipientId: string;
  threadId?: string;
}

export const contactContextId = (recipientType: ParticipantType, recipientId: string): string =>
  `contact:${recipientType}:${recipientId}`;

export const getCommunicationContactPath = ({
  recipientType,
  recipientId,
  threadId,
}: GetCommunicationContactPath): string => {
  const params = new URLSearchParams();

  params.set(SHELL_PARAM.context, contactContextId(recipientType, recipientId));
  if (threadId) params.set(SHELL_PARAM.thread, threadId);

  return `${PagePaths.communications}?${params.toString()}`;
};
